{
  "boundary": {
    "title": "Sesuatu telah berlaku",
    "description": "Bahagian halaman ini tidak dapat dipaparkan. Kerja anda tidak hilang — sebarang larian yang telah bermula masih berjalan di pelayan.",
    "reference": "Rujukan: {{reference}}"
  },
  "route": {
    "title": "Halaman ini tidak dapat dimuatkan",
    "description": "Cuba lagi, atau kembali ke projek anda."
  },
  "notFound": {
    "title": "Halaman tidak dijumpai",
    "description": "Halaman yang anda minta tidak wujud, atau anda tidak lagi mempunyai akses kepadanya."
  },
  "api": {
    "offline": {
      "title": "Tidak dapat menghubungi Planetra",
      "description": "Sambungan anda terputus, atau perkhidmatan tidak memberi respons. Apa-apa yang sedang berjalan diteruskan di pelayan."
    },
    "unauthenticated": {
      "title": "Sila log masuk semula",
      "description": "Sesi anda telah tamat."
    },
    "forbidden": {
      "title": "Anda tiada akses",
      "description": "Ini milik organisasi yang anda bukan ahlinya, atau peranan anda tidak mengizinkannya. Semak organisasi yang sedang dipilih."
    },
    "notFound": {
      "title": "Tidak dijumpai",
      "description": "Ini sudah tiada, atau anda tidak lagi mempunyai akses kepadanya."
    },
    "conflict": {
      "title": "Ini telah berubah sejak anda membukanya",
      "description": "Orang lain telah mengubahnya. Muat semula untuk melihat versi terkini sebelum mencuba lagi."
    },
    "gone": {
      "title": "Pautan ini telah tamat tempoh",
      "description": "Pautan muat turun hanya sah untuk seketika. Minta pautan baharu."
    },
    "validation": {
      "title": "Semak ruangan yang ditandakan",
      "description": "Sebahagian daripada apa yang anda masukkan tidak dapat diterima."
    },
    "rateLimited": {
      "title": "Terlalu banyak percubaan",
      "description": "Tunggu sebentar sebelum mencuba lagi.",
      "descriptionAfter": "Cuba lagi dalam {{seconds}} saat."
    },
    "server": {
      "title": "Berlaku masalah di pihak kami",
      "description": "Ini bukan salah anda. Cuba lagi sebentar nanti — jika ia berterusan, hubungi sokongan."
    },
    "unknown": {
      "title": "Berlaku masalah",
      "description": "Permintaan tidak selesai. Cuba lagi."
    },
    "cancelled": {
      "title": "Dibatalkan",
      "description": "Permintaan telah dihentikan."
    },
    "codes": {
      "session_revoked": {
        "title": "Anda telah dilog keluar",
        "description": "Sesi ini telah dilog keluar daripada peranti lain. Log masuk semula untuk meneruskan."
      },
      "oauth_failed": {
        "title": "Log masuk Google tidak selesai",
        "description": "Log masuk dengan Google tidak selesai. Cuba lagi, atau gunakan e-mel dan kata laluan anda."
      },
      "oauth_email_unverified": {
        "title": "E-mel Google anda belum disahkan",
        "description": "Sahkan alamat e-mel anda dengan Google, kemudian cuba lagi."
      },
      "oauth_account_exists": {
        "title": "Akaun sedia ada menggunakan e-mel ini",
        "description": "Log masuk dengan e-mel dan kata laluan anda sebaliknya."
      }
    },
    "offlineBanner": {
      "label": "Status sambungan",
      "message": "Anda di luar talian. Planetra akan menyambung semula dengan sendirinya."
    }
  }
}
